import React, { useEffect } from 'react';
import { ErrorComponent } from '../components/loading-manager/error-component';
import { PortalContext } from '../context/portal-context';
import { useTrackingManager } from '../tracking/use-tracking-manager';
import { useUniversalEffect } from '@volkswagen-onehub/vw-starter-feature-app-support';
import { usePageTracker } from '../hooks/use-page-tracker';
import { ClubVolkswagenPages, ClubVolkswagenPagesInfo } from './model/club-volkswagen-pages-info';

export const UnexpectedErrorPage = () => {
	const { pageInfoService } = React.useContext(PortalContext);
	const trackingManager = useTrackingManager();
	const pageInfo = ClubVolkswagenPagesInfo[ClubVolkswagenPages.UnexpectedErrorPage];

	useUniversalEffect(() => {
		pageInfoService.setPageInfo({
			seo: { pageTitle: pageInfo.seoTitle },
		});
	}, [pageInfoService]);

	usePageTracker({ contentId: pageInfo.contentId });

	useEffect(() => {
		trackingManager.trackClubVWErrorMessageLoad(
			{
				message: 'Uy, algo no está funcionando.',
			},
			{
				contentId: `Error: AuthProxy - Estado imposible de usuario`,
			},
		);
	}, []);

	return <ErrorComponent />;
};
